/* The existing page and scenario JSON supply every job detail. Enhance the three
   source panels into a visitor-controlled request, computer, approval, and log.
   Without JavaScript the original complete story remains readable. */
(function () {
  'use strict';
  var demo = document.querySelector('[data-uc-demo]');
  var data = document.getElementById('uc-scenarios');
  if (!demo || !data) return;
  var q = demo.querySelector('[data-uc-q]');
  var source = [].slice.call(demo.querySelectorAll('.uc-step'));
  var extra;
  try { extra = JSON.parse(data.textContent).scenarios; } catch (e) { return; }
  if (!q || source.length !== 3 || !Array.isArray(extra)) return;
  var $ = function (s, r) { return (r || demo).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || demo).querySelectorAll(s)); };
  function text(el) { return el ? el.textContent.trim() : ''; }
  function node(tag, cls, value) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (value != null) el.textContent = value;
    return el;
  }
  function button(cls, label) {
    var el = node('button', cls, label); el.type = 'button'; return el;
  }
  var headings = source.map(function (s) { return $('h3', s); });
  var paragraphs = source.map(function (s) { return $('.uc-step__p', s); });
  var log = $('.uc-log'), logLis = $$('.uc-log li');
  var scr = $('.uc-scr'), scrH = $('.uc-scr__h'), rowsB = $$('.uc-r b');
  var card = $('.uc-ap'), cardT = $('.uc-ap__t'), cardN = $('.uc-ap__n');
  var cta = $('[data-uc-act="approve"]'), msg = $('.uc-ap__msg');
  if (!log || !scr || !card || !cta || !msg) return;
  var base = { steps: [
    {h:text(headings[0]), p:text(paragraphs[0]), log:logLis.map(function (li) {return ['ok',text(li.lastElementChild)];})},
    {h:text(headings[1]), p:text(paragraphs[1]), card:{title:text(cardT),note:text(cardN),cta:text(cta)}},
    {h:text(headings[2]),p:text(paragraphs[2]),screen:text(scrH),rows:rowsB.map(text)}
  ]};
  var all = [base].concat(extra), cur = 0, active = 0, approved = false;
  var labels = ['Request', 'Working', 'Needs your approval', 'Done and logged'];
  var btns = $$('.uc-q__b', q), flow = $('.uc-flow'), rail = $('.uc-rail');
  var work = node('li','uc-step uc-work');
  work.appendChild($('.uc-step__h',source[1]));
  work.appendChild(paragraphs[1]);
  var approvalHeading = node('div','uc-step__h');
  approvalHeading.appendChild(node('h3','',labels[2]));
  source[1].insertBefore(approvalHeading,source[1].firstChild);
  flow.insertBefore(work,source[1]);
  var stages = [source[0],work,source[1],source[2]];
  stages.forEach(function (s,i) { s.removeAttribute('data-step'); s.setAttribute('data-uc-stage',String(i)); s.id='uc-stage-'+i; });
  // App chrome uses the page's own screen name, draft, and recorded checks.
  var requestApp = node('div','uc-app uc-app--request');
  requestApp.appendChild(node('div','uc-app__bar',labels[0]));
  var requestBody = node('div','uc-app__request'); requestBody.appendChild(paragraphs[0]);
  requestApp.appendChild(requestBody); source[0].appendChild(requestApp);
  var app = node('div','uc-app uc-app--work');
  var appbar = node('div','uc-app__bar');
  var appName = node('b','',base.steps[2].screen); appbar.appendChild(appName);
  appbar.appendChild(node('span','uc-app__badge','Draft')); app.appendChild(appbar);
  var workspace = node('div','uc-workspace'), draft = node('div','uc-draft');
  draft.appendChild(node('p','uc-draft__label','Draft')); draft.appendChild(paragraphs[1]);
  log.removeAttribute('aria-hidden'); workspace.appendChild(log); workspace.appendChild(draft);
  app.appendChild(workspace); work.appendChild(app);
  scr.removeAttribute('aria-hidden'); card.appendChild(msg);
  var completion = node('p','uc-completion','Approved by you. Logged on the record.');
  source[2].insertBefore(completion, $('.uc-v',source[2]));
  var approvedDraft = node('div','uc-approved-draft'); approvedDraft.hidden=true;
  approvedDraft.appendChild(node('p','uc-draft__label','Draft'));
  var approvedText = node('p'); approvedDraft.appendChild(approvedText); source[2].appendChild(approvedDraft);
  var editor = node('textarea','uc-editor'); editor.hidden = true;
  editor.setAttribute('data-uc-draft',''); editor.setAttribute('aria-label','Edit draft');
  card.insertBefore(editor,$('.uc-ap__acts'));
  // Keep controls outside the changing screen. Approval is never automatic.
  demo.removeAttribute('data-player'); demo.removeAttribute('data-start'); demo.removeAttribute('data-first-run');
  cta.removeAttribute('data-pl-go');
  var oldToggle = $('[data-pl-toggle]');
  var rewind = button('uc-control','Rewind'); rewind.setAttribute('data-uc-rewind','');
  if (oldToggle) oldToggle.replaceWith(rewind);
  var live = $('.uc-live'); if (live) live.replaceChildren(node('span','','Sample'));
  rail.replaceChildren(); rail.className='uc-rail uc-stage-nav'; rail.setAttribute('aria-label','Workflow steps');
  var tabs = labels.map(function (label,i) {
    var li=node('li'), b=button('uc-stage-tab',label);
    b.prepend(node('span','uc-stage-tab__n',String(i+1)));
    b.setAttribute('data-uc-stage-go',String(i));b.setAttribute('aria-controls',stages[i].id);
    b.addEventListener('click',function(){go(i);});li.appendChild(b);rail.appendChild(li);return b;
  });
  $('.uc-main').insertBefore(rail,flow);
  var controls=node('div','uc-controls');
  var back=button('uc-control','Back'), next=button('uc-control uc-control--next','Next');
  back.setAttribute('data-uc-back','');next.setAttribute('data-uc-next','');
  var progress=node('span','uc-progress');progress.setAttribute('role','status');progress.setAttribute('aria-live','polite');
  controls.append(back,progress,next);$('.uc-main').appendChild(controls);
  var artTemplate=$('[data-uc-art]'), art=null;
  if (artTemplate) {art=node('div','uc-operator');art.appendChild(artTemplate.content.cloneNode(true));$('.uc-how .w-wrap',document).insertBefore(art,demo);}
  function go(i) {
    if (i < 0 || i > 3 || (i===3 && !approved)) return;
    active=i;demo.setAttribute('data-active',String(i));editor.readOnly=approved;
    stages.forEach(function(s,k){s.hidden=k!==i;});
    tabs.forEach(function(b,k){b.disabled=k===3&&!approved;if(k===i)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});
    back.disabled=i===0;next.disabled=i>=2;progress.textContent=(i+1)+' / 4';
    $$('.uc-r').forEach(function(r){var k=+r.getAttribute('data-step');r.classList.toggle('is-done',approved||k===0);r.classList.toggle('is-active',!approved&&k===1);r.classList.toggle('is-todo',!approved&&k===2);});
    var ok=$('.uc-ap__ok');ok.hidden=!approved;ok.style.display=approved?'flex':'none';
    $('.uc-ap__acts').hidden=approved;
    if(art) $$('[data-uc-art-state]',art).forEach(function(img){img.hidden=img.getAttribute('data-uc-art-state')!==(i===2?'asking':i===3?'done':'working');});
  }
  function resetDecision() {
    approved=false;editor.hidden=true;editor.value='';msg.hidden=true;msg.textContent='';approvedDraft.hidden=true;approvedText.textContent='';
    demo.removeAttribute('data-uc-approved');
  }
  function apply(i) {
    var s=all[i];if(!s)return;cur=i;resetDecision();
    headings.forEach(function(h,k){h.textContent=s.steps[k].h;paragraphs[k].textContent=s.steps[k].p;});
    logLis.forEach(function(li,k){var l=s.steps[0].log[k]||['ok',''];li.lastElementChild.textContent=l[1];var tick=$('.uc-tick',li),use=$('use',li);tick.classList.toggle('uc-tick--flag',l[0]==='flag');if(use)use.setAttribute('href',l[0]==='flag'?'#i-flag':'#i-check');});
    cardT.textContent=s.steps[1].card.title;cardN.textContent=s.steps[1].card.note;cta.textContent=s.steps[1].card.cta||'Approve';
    var screen=s.steps[2].screen||'Records';
    var draftWords=s.steps[1].h+' '+s.steps[1].p;
    var workScreen=/\b(email|inbox)\b/i.test(draftWords)?'Email':/\b(text|texts|message|messages|reply|replies)\b/i.test(draftWords)?'Messages':/\b(document|documents|agreement|proposal|contract)\b/i.test(draftWords)?'Documents':screen;
    appName.textContent=workScreen;
    app.setAttribute('data-app',/message|email|inbox/i.test(workScreen)?'messages':/calendar|schedule/i.test(workScreen)?'calendar':/document|report|plan|draft/i.test(workScreen)?'document':'records');
    if(scrH.lastChild&&scrH.lastChild.nodeType===3)scrH.lastChild.nodeValue=screen;
    rowsB.forEach(function(b,k){b.textContent=s.steps[2].rows[k]||'';});
    btns.forEach(function(b,k){if(k===i)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
    go(0);
  }
  btns.forEach(function(b,k){b.addEventListener('click',function(){apply(k);});});
  q.addEventListener('keydown',function(e){
    var i=btns.indexOf(document.activeElement);if(i<0)return;var n=-1;
    if(e.key==='ArrowDown'||e.key==='ArrowRight')n=(i+1)%btns.length;
    if(e.key==='ArrowUp'||e.key==='ArrowLeft')n=(i+btns.length-1)%btns.length;
    if(e.key==='Home')n=0;if(e.key==='End')n=btns.length-1;
    if(n>=0){e.preventDefault();btns[n].focus();}
  });
  rail.addEventListener('keydown',function(e){
    var i=tabs.indexOf(document.activeElement);if(i<0)return;var n=i;
    if(e.key==='ArrowRight'||e.key==='ArrowDown')n=Math.min(approved?3:2,i+1);
    else if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=Math.max(0,i-1);
    else if(e.key==='Home')n=0;else if(e.key==='End')n=approved?3:2;else return;
    e.preventDefault();go(n);tabs[n].focus();
  });
  back.addEventListener('click',function(){go(active-1);});next.addEventListener('click',function(){go(active+1);});
  rewind.addEventListener('click',function(){apply(cur);});
  demo.addEventListener('click',function(e){
    var b=e.target.closest('[data-uc-act]');if(!b)return;
    var act=b.getAttribute('data-uc-act');
    if(act==='edit'){editor.hidden=false;if(!editor.value)editor.value=paragraphs[1].textContent;editor.focus();}
    if(act==='approve'){if(!editor.hidden){approvedText.textContent=editor.value;approvedDraft.hidden=false;}approved=true;demo.setAttribute('data-uc-approved','');msg.hidden=true;go(3);}
    if(act==='reject'){approved=false;msg.textContent=b.getAttribute('data-msg');msg.hidden=false;go(2);}
  });
  var touch=null;
  flow.addEventListener('touchstart',function(e){if(e.touches.length===1&&!e.target.closest('button,textarea,input,a'))touch={x:e.touches[0].clientX,y:e.touches[0].clientY};else touch=null;},{passive:true});
  flow.addEventListener('touchend',function(e){if(!touch||!e.changedTouches.length)return;var dx=e.changedTouches[0].clientX-touch.x,dy=e.changedTouches[0].clientY-touch.y;touch=null;if(Math.abs(dx)>65&&Math.abs(dx)>Math.abs(dy)*1.5)go(active+(dx<0?1:-1));},{passive:true});
  demo.__player={go:go,pause:function(){},resume:function(){},restart:function(){apply(cur);}};
  demo.classList.add('is-live');
  demo.setAttribute('data-uc-computer','');apply(0);
})();
